import React from "react"
import _ from "lodash"
import { styled } from "@mui/material/styles"
import axios from "axios"

import LoadingGifFile from "images/loading-more.gif"
import Sample from "../models/sample"
import Collection from "../models/collection"

import { action, runInAction } from "mobx"
import { inject } from "mobx-react"
import { getCsrfToken } from "../utils/userUtils"

const LoadMoreButtonContainer = styled('div')`
  display: flex;
  justify-content: center;
  height: 60px;
  margin: ${(props) =>
    props.loadMoreBtnVisible ? "0 auto" : "20px auto 0 auto"};
  width: 98%;
`

const LoadingGif = styled('img')`
  height: 64px;
  padding-bottom: 10px;
`

// In order to optionally check if certain stores are injected
// https://github.com/mobxjs/mobx-react/issues/232
@inject((props, stores, context) => props)
export default class LoadMoreButton extends React.Component {
  static defaultProps = {
    infiniteScrollEnabled: true,
  }

  constructor(props) {
    super(props)

    this.state = {
      nextPage: props.pagyMetadata.next,
      loadMoreBtnVisible: true,
      isLoading: false,
      showError: false,
    }
  }

  componentDidUpdate(prevProps) {
    // When pagyMetadata changes on filtering we need to update nextPage
    if (this.props.pagyMetadata.next !== prevProps.pagyMetadata.next) {
      this.setState({ nextPage: this.props.pagyMetadata.next });
    }
  }

  componentDidMount() {
    const { infiniteScrollEnabled } = this.props
    if (infiniteScrollEnabled) {
      window.addEventListener("scroll", this.handleScroll)
    }
  }

  componentWillUnmount() {
    const { infiniteScrollEnabled } = this.props
    if (infiniteScrollEnabled) {
      window.removeEventListener("scroll", this.handleScroll)
    }
  }

  @action
  loadMore = async (next_url) => {
    axios.defaults.headers.common["Accept"] = "application/json"
    axios.defaults.headers.common["X-CSRF-Token"] = getCsrfToken()
    const { sampleStore, collectionStore } = this.props
    try {
      const response = await axios({
        url: next_url,
        responseType: "json",
      })

      runInAction(() => {
        if (sampleStore) {
          response.data.samples?.forEach((sampleJSON) => {
            const sample = new Sample(sampleJSON)
            sampleStore.addSample(sample)
          })
        }
        if (collectionStore) {
          response.data.collections?.forEach((collectionJSON) => {
            const collection = new Collection(collectionJSON)
            collectionStore.visibleCollections.push(collection)
            collectionStore.addUniqueAvailableCollection(collection)
          })
        }
      })
      return true
    } catch (error) {
      console.error("getSamples error", error)
      return false
    }
  }

  handleLoadMoreClick = async () => {
    const { pagyMetadata, infiniteScrollEnabled } = this.props
    const { scaffold_url, last } = pagyMetadata
    let { nextPage, isLoading } = this.state

    if (nextPage !== null && isLoading === false) {
      this.setState({ isLoading: true })
      const nextPageUrl = _.replace(scaffold_url, "__pagy_page__", nextPage)
      const didLoad = await this.loadMore(nextPageUrl)
      if (didLoad) {
        const nextNextPage = nextPage < last ? nextPage + 1 : null
        const loadMoreBtnVisible = !infiniteScrollEnabled
        this.setState({
          nextPage: nextNextPage,
          loadMoreBtnVisible: loadMoreBtnVisible,
          isLoading: false,
        })
      } else {
        this.setState({ showError: true })
      }
    }
  }

  handleScroll = async () => {
    const { pagyMetadata } = this.props
    const { scaffold_url, last } = pagyMetadata
    const { loadMoreBtnVisible, nextPage, isLoading } = this.state
    const isScrolledDown =
      window.scrollY >
      document.documentElement.scrollHeight - window.innerHeight - 400

    if (
      loadMoreBtnVisible === false &&
      isLoading === false &&
      isScrolledDown &&
      nextPage
    ) {
      this.setState({ isLoading: true })
      const nextPageUrl = _.replace(scaffold_url, "__pagy_page__", nextPage)
      const didLoad = await this.loadMore(nextPageUrl)
      const nextNextPage = nextPage < last ? nextPage + 1 : null

      if (didLoad) {
        this.setState({ nextPage: nextNextPage, isLoading: false })
      } else {
        this.setState({ showError: true })
      }
    }
  }


  render() {
    const { loadMoreBtnVisible, nextPage, isLoading, showError } = this.state

    if (nextPage && loadMoreBtnVisible && !isLoading) {
      return (
        <LoadMoreButtonContainer loadMoreBtnVisible={loadMoreBtnVisible}>
          <a
            className="load-more-btn btn waves-effect waves-teal center"
            onClick={this.handleLoadMoreClick}
            role="button"
          >
            Load more
          </a>
        </LoadMoreButtonContainer>
      )
    } else if (nextPage && isLoading) {
      return (
        <LoadMoreButtonContainer loadMoreBtnVisible={loadMoreBtnVisible}>
          <LoadingGif src={LoadingGifFile} alt="Loading more GIF" aria-busy="true" aria-live="polite" aria-label="Loading more" />
        </LoadMoreButtonContainer>
      )
    } else if (showError) {
      return (
        <p className="flow-text">
          Something went wrong. Please reload the page and try again.
        </p>
      )
    } else {
      return null
    }
  }
}
